// extracted by mini-css-extract-plugin
export default {"sentBody":"Soon_sentBody__H5EXf"};